<template>
  <b-modal
    v-model="visible"
    title="Nhận hàng về"
    size="md"
    @hidden="onHidden"
  >
    <template v-if="item">
      <div class="mb-3 p-2 border rounded bg-light small">
        <div><b>Mã phiếu:</b> {{ item.code }}</div>
        <div>
          <b>Tên hàng:</b> {{ item.productName || (item.warranty && item.warranty.productName) }}
        </div>
        <div><b>IMEI:</b> {{ item.imeiCode || (item.warranty && item.warranty.imeiCode) }}</div>
        <div><b>NCC:</b> {{ item.providerName }}</div>
        <div><b>Ngày gửi:</b> {{ formatDate(item.sentDate) }}</div>
        <div><b>Chi phí dự kiến:</b> {{ convertPrice(item.estimatedCost) }}</div>
      </div>
      <b-form-group
        label="Ngày nhận về"
        label-class="font-weight-bold"
        class="required-control"
      >
        <date-picker
          v-model="form.actualReceiveDate"
          class="form-control form-control-sm"
          :config="dpConfigs.date"
          placeholder="Chọn ngày"
        />
      </b-form-group>
      <b-form-group
        label="Chi phí thực tế"
        label-class="font-weight-bold"
      >
        <BInputNumber
          :value="form.actualCost"
          @valueChange="(v) => (form.actualCost = v)"
          placeholder="0"
          size="sm"
        />
      </b-form-group>
      <b-form-group label="Ghi chú nhận hàng / kết quả sửa">
        <b-form-textarea
          v-model="form.receiveNote"
          rows="3"
          placeholder="Nhập ghi chú"
        />
      </b-form-group>
    </template>
    <template #modal-footer>
      <b-button
        size="sm"
        variant="secondary"
        @click="hide"
        >Huỷ</b-button
      >
      <SaveButton
        :is-busy="isBusy"
        text="Xác nhận nhận hàng"
        variant="primary"
        size="sm"
        @click="onConfirm"
      />
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment'
import timeUtils from '@/utils/date'
import { convertToDateSlash, DATE_FORMAT } from '@/utils/date'
import { convertPrice, makeToastFaile } from '@/utils/common'
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue'
import SaveButton from '@/view/components/common/SaveButton.vue'
import { receiveOutsource } from '../warrantyOutsourceApi'

export default {
  name: 'ReceiveOutsourceModal',
  components: { BInputNumber, SaveButton },
  props: {
    item: { type: Object, default: null },
  },
  data() {
    return {
      visible: false,
      isBusy: false,
      dpConfigs: timeUtils.DP_CONFIG,
      form: {
        actualReceiveDate: null,
        actualCost: null,
        receiveNote: '',
      },
    }
  },
  methods: {
    convertPrice,
    formatDate(v) {
      return convertToDateSlash(v, DATE_FORMAT) || '—'
    },
    show() {
      this.visible = true
      this.form = {
        actualReceiveDate: moment().toDate(),
        actualCost: this.item?.actualCost ?? this.item?.estimatedCost ?? null,
        receiveNote: this.item?.receiveNote ?? '',
      }
    },
    hide() {
      this.visible = false
    },
    onHidden() {
      this.$emit('hidden')
    },
    validate() {
      const messages = []
      if (!this.form.actualReceiveDate) messages.push('Bắt buộc chọn ngày nhận về')
      messages.forEach((msg) => makeToastFaile(msg))
      return messages.length === 0
    },
    async onConfirm() {
      if (!this.validate() || !this.item || this.isBusy) return
      this.isBusy = true
      try {
        const d = this.form.actualReceiveDate
        const actualReceiveDate = d
          ? timeUtils.formatDate(d, timeUtils.YEAR_MONTH_DAY_FORMAT)
          : null
        await receiveOutsource(this.item.id, {
          actualReceiveDate,
          actualCost:
            this.form.actualCost != null && this.form.actualCost !== ''
              ? Number(this.form.actualCost)
              : null,
          receiveNote: this.form.receiveNote?.trim() || null,
        })
        this.hide()
        this.$emit('done')
      } catch {
      } finally {
        this.isBusy = false
      }
    },
  },
}
</script>

<style scoped>
/* b-form-group không có label-for render <legend> thay vì <label>, nên cần thêm rule cho legend */
.required-control :deep(legend)::after,
.required-control :deep(label)::after {
  content: '*';
  color: red;
  font-weight: bold;
}
</style>
